<template>
  <section class="choose-theme-sec chooseThemeBg">
    <div class="container">

    	<div class="card-title">
    		<h2>First, Choose Your Theme</h2>
    		<p>Select story theme that you want to write</p>
    	</div>

    	<div class="box-wrap">
    		<div class="box-single" 
    			 v-for="item in items" 
    			 :key="item.id" 
    			 @click="selectBox(item.id)"
    			 :class="selectedBox==item.id ? 'active' : ''">
    			<div class="box-header">
    				<img src="../assets/icon/check-box-large.svg" alt="icon" v-if="selectedBox==item.id">
    				<img src="../assets/icon/checkbox-lg.svg" alt="icon" v-else>
    				<h3>{{ item.title}}</h3>
    			</div>
    			<div class="box-media">
    				<img src="../assets/images/mask1.jpeg" alt="mask1">
    			</div>
    		</div>
    		<!-- /. box-single -->
    	</div>
    	<button type="submit" class="next-btn" @click="submitTheme">Next</button>
    </div>
  </section>
</template>

<script>
import { EventBus } from '../main';

export default {
    data() {
      return {
        isActive:false,
        selectedBox:'',
        items: [
	      {
	        id: 1,
	        title: 'Fiction',
	        images: '../assets/images/mask1.jpeg'
	      },
	      {
	        id: 2,
	        title: 'Romantic',
	        images: '../assets/images/mask2.jpeg'
	      },
	      {
	        id: 3,
	        title: 'Animals',
	        images: '../assets/images/mask3.jpeg'
	      },
	      {
	        id: 4,
	        title: 'Love',
	        images: '../assets/images/mask4.jpeg'
	      },
	      {
	        id: 5,
	        title: 'Fiction 5',
	        images: '../assets/images/mask1.jpeg'
	      },
          {
            id: 6,
            title: 'Fiction 5',
            images: '../assets/images/mask1.jpeg'
          },
	    ],
      }
    },

    methods: {
    	selectBox(id){
    		this.selectedBox=id;
    	},

    	submitTheme(){
    		this.$Progress.start();
    		if(!this.selectedBox==''){
    			this.$Progress.finish();
    			this.$router.push('story-create');
    		} else {
    			this.$Progress.fail();
    		}
    	},


        isCurrentRoute() {

          let url = this.$route.path;

          if(url==='/'){
            EventBus.$emit('isCurrentRoute',false);
          } 
          return;

        }
    },

    mounted() {

     this.isCurrentRoute();
     
    }

};

</script>


